<template>
  <div ref="floatingWindow" class="floating-window" :style="{ top: top + 'px', left: left + 'px', width: width + 'px', height: height + 'px' }">
    <div class="resize-handle bottom-right" @mousedown="startResize"></div>

    <!-- 👉 已适配 背景色 + 字体颜色 -->
    <div class="title-bar" @mousedown="startDrag" :style="{ background: headerBg, color: headerColor }">
      <span>{{ title }}</span>
      <button @click="closeWindow" class="closeWin">X</button>
    </div>

    <div class="content" :style="{ pointerEvents: (dragging || resizing) ? 'none' : 'auto' }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 标题
    title: { type: String, default: "代码编辑器" },
    // 头部背景色
    headerBg: { type: String, default: "#f0f0f0" },
    // 头部文字颜色（已适配）
    headerColor: { type: String, default: "#333" },

    // 宽高
    initWidth: { type: Number, default: 700 },
    initHeight: { type: Number, default: 600 },
    minWidth: { type: Number, default: 300 },
    minHeight: { type: Number, default: 300 },

    // 位置
    position: { type: String, default: "right-bottom" },

    // 关闭回调（只需要这个）
    onClose: {
      type: Function,
      default: () => { }
    }
  },
  data () {
    return {
      dragging: false,
      resizing: false,
      startX: 0,
      startY: 0,
      startWidth: 0,
      startHeight: 0,
      top: 80,
      left: 300,
      width: this.initWidth,
      height: this.initHeight
    };
  },
  mounted () {
    this.initPosition();
  },
  methods: {
    initPosition () {
      const sw = window.innerWidth;
      const sh = window.innerHeight;
      const gap = 20;
      switch (this.position) {
        case "left-top":
          this.left = gap; this.top = gap; break;
        case "right-top":
          this.left = sw - this.width - gap; this.top = gap; break;
        case "left-bottom":
          this.left = gap; this.top = sh - this.height - gap; break;
        default:
          this.left = sw - this.width - gap; this.top = sh - this.height - gap; break;
      }
    },

    // ========== 你的原生逻辑 100% 保留 ==========
    startDrag (event) {
      this.dragging = true;
      this.startX = event.clientX - this.left;
      this.startY = event.clientY - this.top;
      window.addEventListener('mousemove', this.drag);
      window.addEventListener('mouseup', this.stopDrag);
    },
    startResize (event) {
      this.resizing = true;
      this.startX = event.clientX;
      this.startY = event.clientY;
      this.startWidth = this.width;
      this.startHeight = this.height;
      window.addEventListener('mousemove', this.resize);
      window.addEventListener('mouseup', this.stopResize);
    },
    drag (event) {
      if (!this.dragging) return;
      let newLeft = event.clientX - this.startX;
      let newTop = event.clientY - this.startY;
      let winW = window.innerWidth;
      let winH = window.innerHeight;
      if (newLeft < 0) newLeft = 0;
      if (newLeft + this.width > winW) newLeft = winW - this.width;
      if (newTop < 0) newTop = 0;
      if (newTop + this.height > winH) newTop = winH - this.height;
      this.left = newLeft;
      this.top = newTop;
    },
    resize (event) {
      if (!this.resizing) return;
      let newW = this.startWidth + (event.clientX - this.startX);
      let newH = this.startHeight + (event.clientY - this.startY);
      let winW = window.innerWidth;
      let winH = window.innerHeight;
      newW = Math.max(this.minWidth, newW);
      newH = Math.max(this.minHeight, newH);
      if (this.left + newW > winW) newW = winW - this.left;
      if (this.top + newH > winH) newH = winH - this.top;
      this.width = newW;
      this.height = newH;
    },
    stopDrag () {
      this.dragging = false;
      window.removeEventListener('mousemove', this.drag);
      window.removeEventListener('mouseup', this.stopDrag);
    },
    stopResize () {
      this.resizing = false;
      window.removeEventListener('mousemove', this.resize);
      window.removeEventListener('mouseup', this.stopResize);
    },

    // 关闭
    closeWindow () {
      this.onClose();
    }
  }
};
</script>

<style>
.floating-window {
  position: absolute;
  background-color: #fff;
  border: 1px solid #ccc;
  z-index: 1000;
  border-radius: 8px;
  overflow: hidden;
}

.title-bar {
  padding: 5px;
  cursor: move;
  user-select: none;
}

.resize-handle {
  width: 10px;
  height: 10px;
  position: absolute;
  bottom: 0;
  right: 0;
  cursor: nwse-resize;
  background-color: #ccc;
  z-index: 10;
}

.content {
  padding: 0;
  height: calc(100% - 32px);
}

.closeWin {
  float: right;
  border: none;
  background: transparent;
  cursor: pointer;
}
</style>